import { Contract } from 'common/contract'
import { Col } from '../layout/col'
import { LoadingIndicator } from '../widgets/loading-indicator'
import { LoadMoreUntilNotVisible } from 'web/components/widgets/visibility-observer'
import { FeedContractCard } from './feed-contract-card'

export function ContractsGrid(props: {
  contracts: Contract[] | undefined
  loadMore?: () => Promise<boolean>
  trackingPostfix?: string
  breakpointColumns?: { [key: string]: number }
}) {
  const { contracts, loadMore, trackingPostfix } = props
  if (contracts === undefined) {
    return <LoadingIndicator />
  }

  if (contracts.length === 0) {
    return null // handle empty state outside of component
  }

  return (
    <Col className="gap-3">
      {/* Polymarket-style grid: 1 col mobile, 2 cols tablet, 4 cols desktop */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {contracts.map((contract) => (
          <FeedContractCard
            contract={contract}
            key={contract.id}
            trackingPostfix={trackingPostfix}
            size={'sm'}
          />
        ))}
      </div>
      {loadMore && <LoadMoreUntilNotVisible loadMore={loadMore} />}
    </Col>
  )
}
